'use strict';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||!1;descriptor.configurable=!0;if('value'in descriptor)descriptor.writable=!0;Object.defineProperty(target,descriptor.key,descriptor)}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor}}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError('Cannot call a class as a function')}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called')}return call&&(typeof call=='object'||typeof call=='function')?call:self}function _inherits(subClass,superClass){if(typeof superClass!='function'&&superClass!==null){throw new TypeError('Super expression must either be null or a function, not '+typeof superClass)}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:!1,writable:!0,configurable:!0}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass}

const _=require('pulsar-utils/dist-es6/_');
const BaseControllerBackedDirective=require('../../../../dist-es6/client/angularCommon/baseControllerBackedDirective');
const BaseResizableDirectiveController=require('../../../../dist-es6/client/angularCommon/baseResizableDirectiveController');
const Guid=require('pulsar-utils/dist-es6/domain/guid');let

PlotAreaDirective=function(_BaseControllerBacked){_inherits(PlotAreaDirective,_BaseControllerBacked);function PlotAreaDirective(){_classCallCheck(this,PlotAreaDirective);return _possibleConstructorReturn(this,_BaseControllerBacked.apply(this,arguments))}_createClass(PlotAreaDirective,[{key:'objectBindings',get:function()
{
return['timeAxis','height','myself','axisLabelMargins','now','graphBackgroundTop'];
}},{key:'controller',get:function()
{
return PlotAreaDirectiveController;
}}]);return PlotAreaDirective}(BaseControllerBackedDirective);let


PlotAreaDirectiveController=function(_BaseResizableDirecti){_inherits(PlotAreaDirectiveController,_BaseResizableDirecti);_createClass(PlotAreaDirectiveController,null,[{key:'$inject',get:function()
{
return['$scope','$element','$window'];
}}]);

function PlotAreaDirectiveController($scope,$element,$window){_classCallCheck(this,PlotAreaDirectiveController);var _this2=_possibleConstructorReturn(this,
_BaseResizableDirecti.call(this,$scope,$element,$window));

_this2._id=Guid.create();

_this2._svgElement=null;
_this2.myself=_this2;

_this2._axes=new Set;
_this2._plotters=new Set;
_this2._pastFutureMasks=[{
id:'default-past-future-mask',
futureOpacity:.35},
{
id:'duty-past-future-mask',
futureOpacity:.5}];return _this2;

}PlotAreaDirectiveController.prototype.





registerAxis=function registerAxis(axis){
this._axes.add(axis);

if(this._dimensionsValid){
this._updateAxis(axis);
}
};PlotAreaDirectiveController.prototype.

registerPlotter=function registerPlotter(plotter){
this._plotters.add(plotter);

if(this._dimensionsValid){
plotter.redraw();
}
};PlotAreaDirectiveController.prototype.





















_onDimensionsChanged=function _onDimensionsChanged(newDimensions,oldDimensions){var _this3=this;
if(_.exists(this._svgElement)){
angular.element(this._svgElement).remove();
}

if(!this._dimensionsValid){
return;
}

for(let axis of this._axes){
this._updateAxis(axis);
}

const nowPosition=_.exists(this.now)?_.clamp(this.timeAxis.scale(this.now.getTime()),0,this.dimensions.width):0;
const htmlForMasks=this._pastFutureMasks.map(function(mask){
return`<mask id="${mask.id}-${_this3.id}">
                        <rect
                            x="0"
                            y="0"
                            width="${nowPosition}"
                            height="${_this3.dimensions.height}"
                            fill="white"
                            opacity="1">
                        </rect>
                        <rect
                            x="${nowPosition}"
                            y="0"
                            width="${_this3.dimensions.width-nowPosition}"
                            height="${_this3.dimensions.height}"
                            opacity="${mask.futureOpacity}"
                            fill="white">
                        </rect>
                    </mask>`;
}).join('\n');

this._$element[0].innerHTML=
`<svg width="${this.dimensions.width}" height="${this.dimensions.height}" xmlns="http://www.w3.org/2000/svg" version="1.1">
                <defs>
                    <pattern id="cross-hatch" patternUnits="userSpaceOnUse" width="8" height="8">
                        <image xlink:href="/images/sleepCrossHatch.png" x="0" y="0" width="8" height="8"></image>
                    </pattern>
                    ${htmlForMasks}
                </defs>
                <g class="graph-area-background">
                    <rect
                        x="${this.axisLabelMargins.left}"
                        width="${this.graphAreaDimensions.width}"
                        y="${this.axisLabelMargins.top+(_.exists(this.graphBackgroundTop)?this.graphBackgroundTop:0)}"
                        height="${this.graphAreaDimensions.height}">
                    </rect>
                </g>
            </svg>`;
this._svgElement=this._$element[0].getElementsByTagName('svg')[0];

let widthChanged=newDimensions.width!==oldDimensions.width;
let heightChanged=newDimensions.height!==oldDimensions.height;

for(let plotter of this._plotters){
if(_.exists(plotter.horizontalAxis)&&widthChanged||_.exists(plotter.verticalAxis)&&heightChanged||plotter.alwaysRedraw===!0){
plotter.redraw();
}
}
};PlotAreaDirectiveController.prototype.

_updateAxis=function _updateAxis(axis){
switch(axis.orientation){
case'horizontal':
axis.lengthOnScreen=this.graphAreaDimensions.width;
break;
case'vertical':
axis.lengthOnScreen=this.graphAreaDimensions.height;
break;}

};_createClass(PlotAreaDirectiveController,[{key:'id',get:function(){return this._id}},{key:'svgElement',get:function(){return this._svgElement}},{key:'graphAreaDimensions',get:function(){return{width:this.dimensions.width-(this.axisLabelMargins.left+this.axisLabelMargins.right),height:this.dimensions.height-(this.axisLabelMargins.top+this.axisLabelMargins.bottom)}}},{key:'graphAreaBoundaries',get:function(){return{top:this.axisLabelMargins.top,left:this.axisLabelMargins.left,right:this.dimensions.width-this.axisLabelMargins.right,bottom:this.dimensions.height-this.axisLabelMargins.bottom}}}]);return PlotAreaDirectiveController}(BaseResizableDirectiveController);


module.exports=PlotAreaDirective;
//# sourceMappingURL=plotAreaDirective.js.map
